export default __webpack_public_path__ + "static/media/menu_gasdaysummaryreport.1cbac066.svg";